import styled from "styled-components";
const VideosPageDisplay = styled.div`
min-height: 100vh;
	// my css here
`;	export default VideosPageDisplay;
